import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageContainerService {
  /**
   * URLs that should always render full screen (no max-width applied).
   * Override this in customer projects to add/remove entries.
   */
  fullscreenUrls: string[] = [
    '/login',
    '/forgot-password',
    '/reset-password',
    '/admin/page-builder/edit'
  ];
}
